import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function OrderReport() {
    const [data, setdata] = useState([]);
    const [isDownload, setDownload] = useState(false);

    const fetchItems = async () => {
        try {

            const response = await axios.get("http://localhost:8072/OrderSummaryReport" );
            console.log(response);
            setdata(response.data);
            setDownload(true);
        } catch (error) {
            console.error('Error fetching orders:', error.message);
        } finally {
            console.log('Fetch process completed.');
        }
    };

    const download = () => {
        const worksheet = XLSX.utils.json_to_sheet(data);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

        // Write Excel File
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

       
        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, "ReimbursementReport-" + getFormattedDate() + ".xlsx");
        // Helper function to format date as ddMMyyyyhhmmss
        
    }

    const getFormattedDate = () => {
        const now = new Date();
        const pad = (n) => n.toString().padStart(2, '0');
        return (
            pad(now.getDate()) +
            pad(now.getMonth() + 1) +
            now.getFullYear() +
            pad(now.getHours()) +
            pad(now.getMinutes()) +
            pad(now.getSeconds())
        );
    }

    useEffect(() => {
        fetchItems();
    }, []);


    return (
        <>

            <>
                <div className="card aon-card">
                    <div className="card-header aon-card-header"
                    >
                        <h4>
                            Order Summary List
                        </h4>
                        {
                            isDownload && <div class="sf-bd-data-tb-head aon-mob-btn-marb">
                                <button class="admin-button" type="button" onClick={download}>
                                    <i class="fa fa-plus"></i>
                                    Download
                                </button>
                            </div>
                        }
                    </div>
                    <div className="card-body aon-card-body">
                        
                        {
                            data && data?.length > 0 && <div className="sf-bs-data-table">

                                <div className="table-responsive">
                                    
                                    <table className="table table-striped table-bordered example-dt-table aon-booking-table" style={{ width: '100%'}}>
                                        <thead>
                                            <tr>
                                                <th>Indent Code</th>
                                                <th>Indent Date</th>
                                                <th>Order Date</th>
                                                <th>Po Code</th>
                                                <th>Currency Code</th>
                                                <th>Item Code</th>
                                                <th>Item Name</th>
                                                <th>Quantity</th>
                                                <th>Supplier Name</th>
                                                <th>Expected Delivery Date</th>
                                                <th>Remarks</th>
                                                <th>Actual Delivery Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {

                                                data?.map((emp, index) => {                                                

                                                    return (
                                                        <tr key={uuidv4()}>
                                                            <td>{emp.IndentCode}</td>
                                                            <td>{emp.IndentDate ? new Date(emp.IndentDate).toLocaleDateString():""}</td>
                                                            <td>{emp.OrderDate != null ? new Date(emp.OrderDate).toLocaleDateString():""}</td>
                                                            <td>{emp.PoCode}</td>
                                                            <td>{emp.CurrencyCode}</td>
                                                            <td>{emp.ItemCode}</td>
                                                            <td>{emp.ItemDescription}</td>
                                                            <td>{emp.Qty}</td>
                                                            <td>{emp.SupplierName}</td>
                                                            <td>{emp.EstimatedDelivery != null ? new Date(emp.EstimatedDelivery).toLocaleDateString(): ""}</td>
                                                            <td>{emp.Remarks}</td>
                                                            <td>{emp.ActualDeliveryDate != null ? new Date(emp.ActualDeliveryDate).toLocaleDateString(): ""}</td>
                                                        </tr>
                                                    )
                                                })
                                            }

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </>

        </>
    );
}

export default OrderReport;

